import script from "./DelayTime.vue?vue&type=script&setup=true&lang=js"
export * from "./DelayTime.vue?vue&type=script&setup=true&lang=js"

import "./DelayTime.vue?vue&type=style&index=0&id=1fa1a835&lang=css"

const __exports__ = script;

export default __exports__